<template>
  <select v-model="isSelected" name="" class="form-control" style="width:100%">
    <option v-for="(row, index, key) in list" :key="key" :value="index">
      {{ row }}
    </option>
  </select>
</template>
<script>
export default {
  props: ['id', 'selected', 'optionsList', 'target'],
  data() {
    return {
      isSelected: this.selected,
      list: this.optionsList,
    }
  },
  watch: {
    isSelected: function(selectValue) {
      this.$emit('selectEvent', selectValue, this.id, this.target)
    },
    selected: function(value) {
      this.isSelected = value
    },
  },
}
</script>
